import React from 'react'
import NumberIcon from './NumberIcon'
import Stick from './Stick'
import { useEffect, useState } from 'react'
import { ProgressItem as StyledProgressItem } from './styles'
import { DolaThemes } from '../../styles/types'

export interface ProgressItemProps {
  active: boolean
  count: number
  n: number
  onClick?: () => void
  theme: DolaThemes
}

export type ProgressItemComponent = React.FC<ProgressItemProps>

const ProgressItem: ProgressItemComponent = ({
  n,
  active: suppliedActive,
  count,
  onClick,
  theme,
}) => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (active !== suppliedActive) {
      setActive(!!suppliedActive)
    }
  }, [suppliedActive])

  const clickable = !!onClick && active

  const handleClick = () => {
    if (clickable) {
      onClick && onClick()
    }
  }

  return (
    <StyledProgressItem
      short={n === 1}
      clickable={clickable}
      items={count}
      onClick={handleClick}
    >
      <Stick theme={theme} active={active} />{' '}
      {/* use first-of-type when we switch to styled components */}
      <NumberIcon theme={theme} n={n} active={active} />
    </StyledProgressItem>
  )
}

export default ProgressItem
